import { render, staticRenderFns } from "./detailFamilyInfo.vue?vue&type=template&id=701ed2fc&scoped=true&"
import script from "./detailFamilyInfo.vue?vue&type=script&lang=js&"
export * from "./detailFamilyInfo.vue?vue&type=script&lang=js&"
import style0 from "./detailFamilyInfo.vue?vue&type=style&index=0&id=701ed2fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701ed2fc",
  null
  
)

export default component.exports